<template>
  <div class="section-recently-bought" :class="{ large: !recentlyBought.length && isDesktop }">
    <div v-if="isDesktop && recentlyBought.length" class="title-wrapper">
      <p class="section-heading">What Do You Love About This?</p>
      <p @click="openModalShareExperience(true)">See all</p>
    </div>
    <div class="content-wrapper">
      <div class="content-left" :style="{ ...(!isLoadingFinish.recentlyBought && { flexGrow: 1, width: '100%' }) }">
        <img
          v-if="isLoadingFinish.recentlyBought"
          src="/assets/img/recently-bought-banner-new.png"
          alt="review banner"
          :class="[
            'img-review',
            { small: recentlyBought.length > 1 && isDesktop },
            { medium: recentlyBought.length === 1 && isDesktop },
            { large: (!recentlyBought.length || !recentlyBought) && isDesktop },
          ]"
          @click="openModalShareExperience(false)"
        />
        <GFMP v-else :styles="{ borderRadius: '8px', height: '112px', flexGrow: 1 }" />
      </div>
      <div v-if="!isDesktop && recentlyBought.length" class="title-wrapper">
        <p class="section-heading">What Do You Love About This?</p>
        <p @click="openModalShareExperience(true)">See all</p>
      </div>
      <div class="content-right" :class="[{ hidden: !recentlyBought.length && isDesktop }]">
        <div class="section-card-slider list-product-slide trending--recomended-products">
          <div v-if="isLoadingFinish.recentlyBought">
            <div v-if="recentlyBought.length > 1">
              <div v-if="isDesktop" class="hidden-xs hidden-sm">
                <carousel
                  v-if="$SO.size(recentlyBought)"
                  :per-page-custom="[
                    [991, 1],
                    [992, 2],
                  ]"
                  :navigation-enabled="true"
                  :per-page="2"
                  navigation-next-label
                  navigation-prev-label
                  :pagination-enabled="false"
                  class="recent-bought-carousel"
                >
                  <slide v-for="(product, key) in recentlyBought" :key="key">
                    <a class="card-recently-bought__close" @click.prevent="hideProduct(key)">
                      <img src="/assets/img/icon-close-grey.svg" alt="icon-close-modal" />
                    </a>
                    <CardRecentlyBought :review-data="product" :dashboard="true" />
                  </slide>
                </carousel>
              </div>
              <div v-else class="hidden-lg hidden-md">
                <ul class="list-scrollable">
                  <li v-for="(product, key) in recentlyBought" :key="`mobile${key}`">
                    <a class="card-recently-bought__close" @click.prevent="hideProduct(key)">
                      <img src="/assets/img/icon-close-grey.svg" alt="icon-close-modal" />
                    </a>
                    <CardRecentlyBought :review-data="product" :dashboard="true" />
                  </li>
                </ul>
              </div>
            </div>
            <div v-else-if="recentlyBought.length === 1" :class="{ 'full-card-mobile': !isDesktop }">
              <a class="card-recently-bought__close larger" @click.prevent="hideProduct(0)">
                <img src="/assets/img/icon-close-grey.svg" alt="icon-close-modal" />
              </a>
              <CardRecentlyBought :review-data="recentlyBought[0]" :dashboard="true" />
            </div>
          </div>
          <RecentlyBoughtLoader v-else :per-page-custom-props="2" />
        </div>
      </div>
    </div>

    <!-- <ModalShareExperience
      v-if="isShowModalShareExperience"
      :product-list="productOnShareExperience"
      :is-see-all="showSeeAll"
      :is-popular-products="!recentlyBought.length"
    /> -->
  </div>
</template>
<script>
import { get, last } from 'lodash';

export default {
  name: 'RecentlyBought',
  components: {
    CardRecentlyBought: () => import('./card-recently-bought'),
    RecentlyBoughtLoader: () => import('./recently-bought-loader'),
    // ModalShareExperience: () => import('@/components/global/modal/modal-share-experience'),
  },
  data() {
    return {
      skipData: 0,
      limitData: 10,
      isLoadingFinish: {
        recentlyBought: false,
      },
      recentlyBought: [],
      showSeeAll: false,
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
    imgBanner() {
      let result = '';
      if (this.isDesktop) {
        if (this.recentlyBought.length > 1) {
          // result = '/assets/img/banner-review-small.png';
          result = '/assets/img/banner-review-new.png';
        } else if (this.recentlyBought.length === 1) {
          result = '/assets/img/banner-review-new.png';
        } else {
          result = '/assets/img/banner-review-new.png';
        }
      } else {
        result = '/assets/img/banner-review-new.png';
      }
      return result;
    },
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    isShowModalShareExperience() {
      return this.$store.state.modal.isModalShow.shareExperience;
    },
    trendingProducts() {
      return this.$store.state.product && this.$store.state.product.trendingProducts;
    },
    productOnShareExperience() {
      if (this.recentlyBought.length) {
        return this.recentlyBought;
      }
      return this.trendingProducts
        .map((e) => ({
          ...e,
          product_name: e.name,
          image: e.images[0].url,
          manufacturer_name: e.brand.name,
        }))
        .slice(0, 8);
    },
  },
  watch: {
    userProfile(newVal) {
      if (newVal) {
        this.getRecentBought();
      }
    },
  },
  mounted() {
    if (this.userProfile) {
      this.getRecentBought();
    } else {
      this.isLoadingFinish.recentlyBought = true;
    }
  },
  methods: {
    getRecentBought() {
      this.isLoadingFinish.recentlyBought = false;
      this.$MS_ORDER_API_URL
        .get('users/me/recently-bought', {
          params: {
            fields: 'id,images,brand,name,default_combination,combinations',
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const data = ((res.data && res.data.data) || [])
              .map((item) => {
                item['image'] = get(last(item.images || []), 'url', '');
                item['manufacturer_name'] = get(item, 'brand.name', '');
                item['product_name'] = get(item, 'name', '');
                item['combination_id'] = item.default_combination._id
                  ? item.default_combination._id
                  : item.combinations[0]._id;
                return item;
              })
              .reverse()
              .filter((item) => !item.is_reviewed);
            this.recentlyBought = data;
          } else {
            this.recentlyBought = [];
          }
          this.isLoadingFinish.recentlyBought = true;
        })
        .catch((err) => {
          this.recentlyBought = [];
          this.isLoadingFinish.recentlyBought = true;
        });
    },
    hideProduct(key) {
      return this.recentlyBought.splice(key, 1);
    },
    navigateToReviewAdd() {
      if (this.isLogin) {
        this.$router.push('/review/add');
      } else {
        this.$store.commit('setDataModal', {
          modalName: 'loginPage',
          value: 1,
        });
      }
    },
    openModalShareExperience(isSeeAll = false) {
      if (!this.isLogin) {
        this.$store.commit('setModalShareFromLogin', true);
        this.$store.commit('setDataModal', {
          modalName: 'loginPage',
          value: 1,
        });
      } else if (this.isDesktop) {
        this.showSeeAll = isSeeAll;
        this.$store.commit('toggleModalGlobalState', { modalName: 'shareExperience' });
        this.$store.commit('setSeeAll', this.showSeeAll);
      } else {
        if (isSeeAll == true) {
          this.$router.push({ path: '/review/add', query: { is_see_all: isSeeAll } });
        } else {
          this.$router.push('/review/add');
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

@mixin carousel() {
  &::v-deep {
    // .VueCarousel-wrapper {
    //   padding-bottom: 10px;
    // }
    .VueCarousel-pagination {
      bottom: 0;

      .VueCarousel-dot-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;

        button.VueCarousel-dot {
          padding: 0 !important;
          height: 6px !important;
          width: 6px !important;

          &--active {
            height: 10px !important;
            width: 10px !important;
          }
        }
      }
    }

    .VueCarousel-navigation-prev {
      left: 15px;
    }

    .VueCarousel-navigation-next {
      right: 15px;
    }
  }
}

.card-recently-bought__close {
  display: block;
  position: absolute;
  right: 22px;
  top: 10px;
  z-index: 2;
  cursor: pointer;

  &.larger {
    right: 38px;
  }

  img {
    width: 12px;
    height: 12px;
  }
}

.section-recently-bought {
  width: 100%;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.18);
  padding: 16px;
  margin-bottom: 20px;
  border-radius: 4px;

  &.large {
    display: block;

    .content-left {
      width: 100%;
      margin: 0;
    }
  }
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font: 14px/18px 'lato-regular', sans-serif;

    > .section-heading {
      margin: 0;
    }

    > :last-child {
      color: #eb395f;
      cursor: pointer;
    }
  }
  .content-wrapper {
    display: flex;
    align-items: center;
    gap: 48px;
    @media (max-width: 992px) {
      gap: 8px;
      flex-direction: column;
    }
    .content-left {
      .img-review {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
        top: -7px;
        cursor: pointer;

        &.small {
          width: 372px;
        }

        &.medium {
          width: 705px;
        }

        &.large {
          width: 100%;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .content-right {
      position: relative;
      display: flex;
      width: 100%;
      margin: 0;
      padding: 0;

      .recent-bought-carousel {
        width: 665px;
        @include carousel();

        &::v-deep .VueCarousel-inner {
          margin-right: -8px;

          // flex-basis: 328px !important;
          .VueCarousel-slide {
            position: relative;
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .full-card-mobile .card-recently-bought {
      width: 100%;
    }
    box-shadow: none;
    margin-bottom: 0;

    .section-heading {
      font: 16px/22px 'Lato-Bold', sans-serif;
      margin-bottom: 10px;
    }

    .content-left {
      position: relative;
      margin: 0 auto;
      width: 100%;
      display: block;

      .img-review {
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    h3 {
      align-self: flex-start;
      font-family: $lato-bold;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: #231f20;
      margin: 16px 0;
    }
  }
}

.list-product-slide {
  width: 100%;
}

.hidden {
  display: none;
}
</style>
